import { Avatar, Box, Divider, IconButton, Typography, Chip, Card, useTheme } from "@mui/material";
import FechaFunction from "../../function/FechaFunction";
import GroupsIcon from '@mui/icons-material/Groups';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TimerOffIcon from '@mui/icons-material/TimerOff';
const LogsTimeCard = ({
    item,
    keys
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    let texto;
    let statusType = '';
    let statusColor = '#718096';
    let statusIcon = null;
    
    if(item){
        switch (item?.isDeleted_uxt) {
            case true:
            case 1:
                if(item.tipo_uxt === 'DNI'){
                    texto=`estuvo asignado al ticket por ${item?.transcurso}`;
                    statusType = 'FINALIZADO';
                    statusColor = '#6366f1';
                    statusIcon = <TimerOffIcon sx={{ fontSize: 16 }} />;
                }else if(item.tipo_uxt === 'GRUPO'){
                    texto=`estuvo asignado al ticket por ${item?.transcurso}`;
                    statusType = 'FINALIZADO';
                    statusColor = '#6366f1';
                    statusIcon = <TimerOffIcon sx={{ fontSize: 16 }} />;
                }
            break;
            case false:
            case 0:
                if(item.tipo_uxt === 'DNI'){
                    texto=`lleva asignado al ticket por ${item?.transcurso}`;
                    statusType = 'ACTIVO';
                    statusColor = '#10b981';
                    statusIcon = <ScheduleIcon sx={{ fontSize: 16 }} />;
                }else if(item.tipo_uxt === 'GRUPO'){
                    texto=`lleva asignado al ticket por ${item?.transcurso}`;
                    statusType = 'ACTIVO';
                    statusColor = '#10b981';
                    statusIcon = <ScheduleIcon sx={{ fontSize: 16 }} />;
                }
            break;
            default:
                texto='Se ha producido un error';
                statusType = 'ERROR';
                statusColor = '#ef4444';
                statusIcon = <AccessTimeIcon sx={{ fontSize: 16 }} />;
            break;
        }
    }
    return (
        <Card 
            sx={{
                mb: 2,
                p: 2.5,
                borderRadius: 2,
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e7ed',
                background: isDarkMode ? '#2d3a52 !important' : '#ffffff !important',
                transition: 'all 0.2s ease',
                boxShadow: isDarkMode ? '0 4px 12px rgba(0,0,0,0.3)' : '0 4px 12px rgba(0,0,0,0.08)',
            }}
        >
            {/* Header con Avatar y Estado */}
            <Box display='flex' alignItems='center' justifyContent='space-between' mb={1.5}>
                <Box display='flex' alignItems='center' gap={1.5}>
                    {/* Avatar o Icono de Grupo con borde de color */}
                    <Box
                        sx={{
                            p: 0.3,
                            borderRadius: '50%',
                            background: `${statusColor}20`,
                            border: `2px solid ${statusColor}40`
                        }}
                    >
                        {item?.foto_p ? (
                            <Avatar 
                                src={item?.foto_p} 
                                sx={{
                                    width: 36, 
                                    height: 36,
                                    background: isDarkMode ? '#1F2A40' : '#f1f3f5',
                                    border: isDarkMode ? '2px solid #3d4a62' : '2px solid #fff'
                                }} 
                            />
                        ) : (
                            <Box 
                                sx={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    width: 36, 
                                    height: 36,
                                    borderRadius: '50%',
                                    display: 'flex', 
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    border: isDarkMode ? '2px solid #3d4a62' : '2px solid #fff'
                                }}
                            >
                                <GroupsIcon sx={{ color: '#fff', fontSize: 20 }} />
                            </Box>
                        )}
                    </Box>
                    
                    {/* Información del usuario/grupo y tiempo */}
                    <Box>
                        <Box display='flex' alignItems='center' gap={0.5} mb={0.3}>
                            <Typography 
                                sx={{
                                    color: isDarkMode ? '#e0e0e0' : '#2d3748',
                                    fontWeight: 600,
                                    fontSize: 14,
                                    lineHeight: 1.2
                                }}
                            >
                                {item?.nombre_p || item?.nombre_g}
                            </Typography>
                            <Chip 
                                label={item?.tipo_uxt === 'GRUPO' ? 'Grupo' : 'Usuario'}
                                size="small"
                                sx={{
                                    height: 18,
                                    fontSize: 10,
                                    fontWeight: 600,
                                    backgroundColor: item?.tipo_uxt === 'GRUPO' ? '#8b5cf620' : '#0ea5e920',
                                    color: item?.tipo_uxt === 'GRUPO' ? '#8b5cf6' : '#0ea5e9',
                                    border: `1px solid ${item?.tipo_uxt === 'GRUPO' ? '#8b5cf640' : '#0ea5e940'}`,
                                    '& .MuiChip-label': { px: 1 }
                                }}
                            />
                        </Box>
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#b0bec5' : '#4a5568',
                                fontSize: 13,
                                lineHeight: 1.4
                            }}
                        >
                            {texto}
                        </Typography>
                    </Box>
                </Box>
                
                {/* Badge de estado */}
                {statusIcon && (
                    <Chip 
                        icon={statusIcon}
                        label={statusType}
                        size="small"
                        sx={{
                            height: 24,
                            fontSize: 11,
                            fontWeight: 600,
                            backgroundColor: `${statusColor}15`,
                            color: statusColor,
                            border: `1px solid ${statusColor}40`,
                            '& .MuiChip-icon': {
                                color: statusColor,
                                ml: 1
                            }
                        }}
                    />
                )}
            </Box>

            {/* Footer con timestamp */}
            <Box 
                display='flex' 
                alignItems='center' 
                justifyContent='flex-end' 
                gap={0.5}
                pt={1.5}
                borderTop={isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e7ed'}
            >
                <AccessTimeIcon sx={{ fontSize: 14, color: isDarkMode ? '#b0bec5' : '#9ca3af' }} />
                <Typography 
                    sx={{
                        color: isDarkMode ? '#b0bec5' : '#9ca3af',
                        fontSize: 11,
                        fontWeight: 500,
                        letterSpacing: 0.3
                    }}
                >
                    {FechaFunction.format(new Date(item.createdAt), 'dd/MM/yyyy HH:mm:ss')}
                </Typography>
            </Box>
        </Card>
    );
}

LogsTimeCard.defaultProps = {
    canShowMore:false,
    buttons:null,
};

export default LogsTimeCard;
